export const normalizeRoutePath = (route, fallback) => {
  const routePath = typeof route === "string" ? route : route?.RoutePath;
  const normalized = routePath || fallback;
  if (!normalized) return undefined;

  const absolutePath = normalized.startsWith("/") ? normalized : `/${normalized}`;
  return absolutePath.length > 1 ? absolutePath.replace(/\/+$/, "") : absolutePath;
};

const resolveConfiguredRoutePath = (getRoute, screenKey) => {
  if (!getRoute) {
    return undefined;
  }

  return normalizeRoutePath(getRoute(screenKey, "Convoke"));
};

export const CONVOKE_ENTITY_OBJECT_MANAGE_SCREEN_KEY = "/entityobject/manage/";
export const CONVOKE_ENTITY_OBJECT_MODIFY_SCREEN_KEY = "/entityobject/modify/";

export const buildConvokeEntityObjectRoutes = (getRoute) => ({
  manage: resolveConfiguredRoutePath(getRoute, CONVOKE_ENTITY_OBJECT_MANAGE_SCREEN_KEY),
  modify: resolveConfiguredRoutePath(getRoute, CONVOKE_ENTITY_OBJECT_MODIFY_SCREEN_KEY)
});
